<template>
    <v-container fluid class="pa-0">
    <!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            <v-row no-gutters>
                <v-col cols="6" md="8">
                <span class="mr-2">Client</span>
                <v-chip small outlined color="secondary">
                    <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.updatedAt).format('DD MMMM YYYY') }}
                </v-chip>
                </v-col>
                <v-col cols="6" md="4" >
                <v-tabs v-model="activeTab" grow right light> <!-- style="border-radius: 40px !important;" -->
                    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                    <v-tab>Photo</v-tab>
                    <v-tab>Temps</v-tab>
                </v-tabs>
                </v-col>
            </v-row>
        </v-card-title>
        <v-form ref="form" v-model="validForm" lazy-validation>
        <v-row no-gutters>
            <v-col cols="12" md="8">
                <v-row no-gutters>
                <v-col cols="12" md="12" class="pr-2">
                    <v-text-field :rules="nameRules" outlined dense class="rounded-lg" label="Nom" required  v-model="item.ent_name"></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pr-2">
                    <v-text-field prepend-inner-icon="mdi-phone" outlined dense class="rounded-lg" label="Tel" v-model="item.ent_customfields.phone"></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="pr-2">
                    <v-text-field prepend-inner-icon="mdi-cellphone-basic" outlined dense class="rounded-lg" label="Tel mobile" v-model="item.ent_customfields.mobilephone"></v-text-field>
                </v-col>
                <v-col cols="12" md="8" class="pr-2 pb-1">
                    <v-text-field :rules="emailRules" prepend-inner-icon="mdi-card-account-mail-outline" outlined dense class="rounded-lg" label="Email" v-model="item.ent_customfields.ent_email"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" class="pr-2">
                    <v-switch class="mt-0" :true-value="1" :false-value="0" v-model="item.ent_notify" label="Envoyer le bon de passage"></v-switch>
                </v-col>
                <!-- right side -->
                <v-col cols="12" md="11" class="pr-2">
                    <v-autocomplete
                        v-model.trim="searchAddress"
                        label="Rechercher adresse"
                        :items="addressTab"
                        item-value="id" item-text="label"
                        :search-input.sync="search"
                        @change="selectAdress" @focus="searchBoxClosed = false" @blur="searchBoxClosed = true"
                        prepend-inner-icon="mdi-magnify" filled outlined dense clearable no-filter
                        class="inline rounded-lg shrink expanding-search"
                        background-color="white">
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" md="1" class="pr-2">
                    <v-btn outlined color="secondary" class="mb-2" @click="modalGeolocate = !modalGeolocate" title="Localiser manuellement">
                        <v-icon>mdi-map-marker-radius-outline</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="6" class="pr-2">
                    <v-text-field :rules="nameRules" ref="address" outlined dense class="rounded-lg" label="Rue / complément" v-model="item.ent_customfields.ent_address"></v-text-field>
                </v-col>
                <v-col cols="8" md="4" class="pr-2">
                    <v-text-field :rules="nameRules" outlined dense class="rounded-lg" label="Ville" v-model="item.ent_customfields.ent_town"></v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pr-2">
                    <v-text-field outlined dense class="rounded-lg" label="Code postal" v-model="item.ent_customfields.ent_zip"></v-text-field>
                </v-col>
                <v-col cols="12" md="12" class="pr-2">
                    <v-switch v-if="$route.params.ent_id == 0" v-model="createSite" label="Créer un site avec la même adresse"></v-switch>
                </v-col>
            </v-row>
            </v-col>
            <v-col cols="12" md="4" class="pb-5" v-if="activeTab == 0">
                <div class="elevation-0" style="max-width:350px; margin-left:auto; margin-right:auto;">
                <v-carousel v-show="( itemsCarousel.length )" :height="'350px'" ref="resizedImage" class="ml-2 mr-2 elevation-3 rounded-lg">
                    <v-carousel-item
                        v-for="(item,i) in itemsCarousel" :key="i" :src="item.src"
                        reverse-transition="fade-transition" transition="fade-transition" @click="downloadDocument(item)"
                        style="cursor:pointer;">
                        <v-icon left :color="(item.doc_pinned) ? 'red' : 'grey'" title="">
                            {{ (item.doc_pinned) ? 'mdi-heart' : 'mdi-heart-outline' }}
                        </v-icon>
                    </v-carousel-item>
                </v-carousel>
                </div>
            </v-col>
            <v-col cols="12" md="4" class="pb-5" v-if="activeTab == 1 && item.ent_id > 0">
                <CustomerGraph :ent_id="item.ent_id" />
            </v-col>
        </v-row>
        </v-form>
        <v-card-actions>
            <v-btn color="red" v-if="(item.ent_sta_id == 'GEN01') && item.ent_uid && item.ent_uid.length > 5" @click="deleteItem()"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-btn color="orange" v-if="!(item.ent_sta_id == 'GEN02')" @click="item.ent_sta_id = 'GEN02'; saveItem();"><v-icon title="Mettre en veille">mdi-sleep</v-icon> Mettre en veille</v-btn>
            <v-btn color="blue" v-if="(item.ent_sta_id == 'GEN02')" @click="item.ent_sta_id = 'GEN01'; saveItem();"><v-icon title="Mettre en veille">mdi-true</v-icon> Ré-activer</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primmary" href="/#/customers/">Retour</v-btn>
            <v-btn v-if="$root.$permissions.Customer.store" color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="(loading.fetchData || !validForm)">Enregistrer</v-btn>
        </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <fieldset fluid class="mt-5 ma-2 pa-0 elevation-0 rounded-xxl micorise-v-card" style="background-color:#E0F2F1">
        <legend style="margin-left: 1em; padding: 0.2em 0.8em ">Liste des sites / Ajouter un site</legend>
        <SitesList v-if="!loading.fetchData && item.ent_id" :sit_ent_id="item.ent_id" :searchBar="false" class="rounded-xxl" style="background-color:#E0F2F1"/>
    </fieldset>
    <fieldset fluid class="mt-5 ma-2 pa-0 elevation-0 rounded-xxl micorise-v-card" style="background-color:#F9FBE7">
        <legend style="margin-left: 1em; padding: 0.2em 0.8em ">Liste des actions</legend>
        <TasksList v-if="!loading.fetchData && item.ent_id" :sit_ent_id="item.ent_id" :searchBar="true" :addItemButton="false" class="rounded-xxl" style="background-color:#F9FBE7"/>
    </fieldset>
    <v-dialog v-model="modalGeolocate" hide-overlay max-width="900" content-class="rounded-xxl micorise-v-card">
        <MapGeolocate v-if="modalGeolocate" :latLng="{lat: item.ent_lat, lng: item.ent_lng}" :switchGeolocate="switchGeolocate" />
    </v-dialog>
    </v-container>
</template>

<script>
import SitesList  from '@/components/sites/SiteList'
import TasksList  from '@/components/tasks/TaskList'
import MapGeolocate from '@/components/map/MapGeolocatePopup'
import CustomerGraph from '@/components/customers/CustomerGraph'
//import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import { mapWritableState, mapActions, mapState } from 'pinia'
import { useEntityStore } from '@/stores/entity'
import { useSiteStore } from '@/stores/site'
import { useDocumentStore } from '@/stores/document'

import { filterUpdateService } from '@/rxjsServices';

export default {
    name: 'Customer-Edit',
    components: { SitesList, TasksList, MapGeolocate, CustomerGraph },
    computed: {
        ...mapWritableState(useEntityStore, { item: 'item' }),
        ...mapWritableState(useSiteStore, { site: 'item' }),
        ...mapState(useDocumentStore, { documentList: 'itemList' }),
        progress () {
            return (this.item.password) ? Math.min(100, this.item.password.length * 12.5) : 0
        },
        color () {
            return ['error', 'warning', 'success'][Math.floor(this.progress / 50)]
        },
    },
    watch: {
        search (val) {
            this.searchWord = val
            if( this.timeOutHandle == 'off' && val && val.length >= 3 ){
                this.timeOutHandle = 'on'
                clearTimeout(this.searchTempo)
                this.searchTempo = setTimeout( () => {
                    if( this.searchWord ){
                        this.loadAddress(this.searchWord)
                    }
                    this.timeOutHandle = 'off'
                }, 1500)
            }
        },
    },
    data: function () {
        return {
            loading: { fetchData: true },
            createSite: true,
            search: null, searchAddress: null, searchBoxClosed: true, addressTab: [], timeOutHandle: 'off',
            itemsCarousel: [],
            modalGeolocate: false,
            activeTab: -1,
            validForm: true,
            nameRules: [ v => !!v || 'Le champ doit être renseigné', v => (v && v.length <= 100) || 'Doit être inférieur à 100 charactères', ],
            emailRules: [ 
                (v) => ( !v || /.+@.+\..+/.test(v) ) || 'E-mail doit être valide'
            ],
        }
    },
    async beforeMount(){
        this.loading.fetchData = true
        this.setDocumentList( [] )
        await this.fetchItem( this.$route.params.ent_id, '?ent_sta_id=GEN01' )
        //this.loading.fetchData = false
    },
    async mounted () {
        this.loading.fetchData = true
        if( this.$route.params.lat && this.$route.params.lng ){
            this.adresseFromPoint( { lat: this.$route.params.lat, lng: this.$route.params.lng } )
        }
        if( parseInt( this.$route.params.ent_id ) > 0 ){
            await this.fetchDocument('?sit_ent_id=' + this.item.ent_id + '&extended=withtasks&doc_typ_id=DOC03&doc_pinned=1')
            this.getCarouselImage()
        }
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useEntityStore, { fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', destroyItem:'destroyItem' }),
        ...mapActions(useSiteStore, { storeSite: 'storeItem'}),
        ...mapActions(useDocumentStore, { fetchDocument: 'fetchItems', downloadItem: 'downloadItem', setDocumentList: 'SET_ITEMS' }),
        async saveItem () {
            await this.$refs.form.validate()
            if( this.validForm ){
                // Enregistrement du formulaire
                this.loading.fetchData = true
                if( parseInt( this.$route.params.ent_id ) > 0 ){
                    await this.updateItem()
                } else {
                    await this.storeItem()
                    if(this.createSite && this.item.ent_id){
                        this.site.sit_address = this.item.ent_customfields.ent_address
                        this.site.sit_town   = this.item.ent_customfields.ent_town
                        this.site.sit_zip    = this.item.ent_customfields.ent_zip
                        this.site.sit_lat    = this.item.ent_customfields.ent_lat
                        this.site.sit_lng    = this.item.ent_customfields.ent_lng
                        this.site.sit_name   = this.item.ent_name
                        this.site.sit_ent_id = this.item.ent_id
                        this.site.sit_sta_id = 'GEN01'
                        this.storeSite()
                    }
                }
                if( this.$route.matched[1].name == 'map-view' ){
                    filterUpdateService.sendFilter('filter')
                    this.$router.push({ name: this.$route.matched[1].name, params: { ent_id: this.$route.params.ent_id } })
                } else {
                    this.$router.push({ path: '/customers' })
                }
            }
        },
        loadAddress (val) {
            if( val.length > 1 ){
                this.$http.customRequest( {
                    headers: '',
                    baseURL: '',
                    method: 'get',
                    url: "https://api-adresse.data.gouv.fr/search/?q=" + val + "&limit=6"
                })
                .then( (response) => {
                    let data = []
                    let address, key
                    for (key = 0; (address = response.data.features[key]) !== undefined; key++) {
                        data[key] = { label: address.properties.label, value: address.properties.id, id:key, item: address }
                    }
                    this.addressTab = data
                })
            } else {
                return false
            }
        },
        selectAdress(){
            if( this.searchAddress !== null && this.searchAddress !== undefined ){
                this.item.ent_customfields.ent_address = this.addressTab[this.searchAddress]?.item?.properties?.name
                this.item.ent_customfields.ent_town = this.addressTab[this.searchAddress]?.item?.properties?.city
                this.item.ent_customfields.ent_zip = this.addressTab[this.searchAddress]?.item?.properties?.postcode
                this.item.ent_customfields.ent_lat = this.addressTab[this.searchAddress]?.item?.geometry?.coordinates[1]
                this.item.ent_customfields.ent_lng = this.addressTab[this.searchAddress]?.item?.geometry?.coordinates[0]
                this.item.ent_lat= this.item.ent_customfields.ent_lat
                this.item.ent_lng = this.item.ent_customfields.ent_lng
            }
            this.searchAddress = ''
            this.addressTab.splice(0)
            this.$refs.address.focus()
        },
        adresseFromPoint(latLng){
            this.$http.customRequest( {
                headers: '',
                baseURL: '',
                method: 'get',
                url: "https://api-adresse.data.gouv.fr/reverse/?lon=" + latLng.lng + "&lat=" + latLng.lat + ""
            }).then( (response) => {
                if( response.data && response.data.features && response.data.features[0] ){

                    this.item.ent_customfields.ent_address = response.data?.features[0]?.properties.name
                    this.item.ent_customfields.ent_town    = response.data?.features[0]?.properties.city
                    this.item.ent_customfields.ent_zip     = response.data?.features[0]?.properties.postcode
                    this.item.ent_customfields.ent_lat     = latLng.lat
                    this.item.ent_customfields.ent_lng     = latLng.lng
                    this.item.ent_lat     = latLng.lat
                    this.item.ent_lng     = latLng.lng
                }
            })
        },
        async getCarouselImage(){
            this.itemsCarousel = []
            for( const pic in this.documentList ){
                if( this.documentList[pic].doc_typ_id == 'DOC03' ){
                    const img = await this.downloadItem(this.documentList[pic].doc_id, null, '?type=small')
                    if( img.blob && img.blob.size > 0 ){
                        let reader = new FileReader()
                        reader.readAsDataURL(img.blob)
                        reader.onloadend = () => {
                            const base64data = reader.result
                            this.documentList[pic].src = base64data
                            this.itemsCarousel.push( this.documentList[pic] )
                        }
                    }
                    //this.itemsCarousel.unshift( this.documentList[pic] )
                }
            }
        },
        switchGeolocate(latLng){
            if( latLng && latLng.lat ){
                this.item.ent_lat     = latLng.lat
                this.item.ent_lng     = latLng.lng
                if( !this.item.ent_customfields.ent_address  ){
                    this.item.ent_customfields.ent_address = latLng.address
                    this.item.ent_customfields.ent_town    = latLng.town
                    this.item.ent_customfields.ent_zip     = latLng.zip
                    this.item.ent_customfields.ent_lat     = latLng.lat
                    this.item.ent_customfields.ent_lng     = latLng.lng
                }
            }
            this.modalGeolocate = false
        },
        async deleteItem(){
            this.$root.$confirm('Supprimer', 'Confirmer la suppression ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm ){
                    this.destroyItem()
                    this.$root.$toast({ color: 'error', top:false, bottom:true, right:false, left:true, text:'Client supprimé !' })
                    this.$router.push({ path: '/customers' })
                }
            })
        },
    }
}
</script>